var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hideAnimation)?_c('div',{attrs:{"id":"gifan"}},[_c('img',{staticClass:"cross",attrs:{"src":require('@/assets/images/nycross.svg')},on:{"click":_vm.hide}}),_vm._v(" "),_c('img',{staticClass:"main",attrs:{"src":_vm.gifUrl}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/GifAnimation.vue?vue&type=template&id=56cd47d8&
// module id = 953
// module chunks = 0